import { Button, Modal } from "react-bootstrap";
import CommonOrders from "../../common/CommonOrders"
import CommonMessage from "../../common/CommonMessage";
import { useCallback, useState } from "react";
import CButton from "../../common/CButton";
import { AddNDRRemarks } from "../../services/ndrService";
const PendingNDR=()=>{
    const [ndrStatus, setNdrStatus] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [remarksLoading, setRemarksLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [formData, setFormData] = useState({
    remarks: "",
    responseStatus: "",
    responseDate: "",
});

    const openRemarksPopup = useCallback((rowData) => {
            setSelectedRow(rowData);
            setShowModal(true);
            setFormData({
    remarks: "",
    responseStatus: "",
    responseDate: "",
});
            setErrors({});
        }, []);
         const closeRemarksPopup = useCallback(() => {
                setShowModal(false);
                setSelectedRow(null);
                setFormData({
    remarks: "",
    responseStatus: "",
    responseDate: "",
});
                setErrors({});
            }, []);
const validate = useCallback(() => {
    const newErrors = {};

    if (!formData.remarks.trim()) {
        newErrors.remarks = "Please enter response remark.";
    }

    if (!formData.responseStatus) {
        newErrors.responseStatus = "Please select response status.";
    }

    // Optional
    // if (!formData.responseDate) {
    //     newErrors.responseDate = "Please select response date.";
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
}, [formData]);

    // Confirm Cancel
      const handleRemarksNDR = async () => {
    if (!selectedRow || !validate()) return;

    setRemarksLoading(true);

    try {
        // API call
        const payload = {
            orderId:selectedRow.id,
            responseStatus:formData.responseStatus,
            remarksDate:formData.responseDate,
            remarks:formData.remarks,
            ndrDate:selectedRow.ndrDate
        };
const response= await AddNDRRemarks(payload);
if(response.statusCode===200)
{
    setMessage(response.message || "Remarks added successfully.");
    // Force CommonOrders to remount
    setRefreshKey(prev => prev + 1);
}
else
{
    setMessage(response?.message || "Unable to save remarks.");
}
        closeRemarksPopup();
    } catch (err) {
        setMessage(
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong."
        );
    } finally {
        setRemarksLoading(false);
    }
};
     const handleChange = ({ target: { name, value } }) => {
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));

        setErrors(prev => ({
            ...prev,
            [name]: "",
        }));
    };
     const columnDefs = [
        {
            headerName: "Remarks",
            cellRenderer: (params) => (
                <CButton
                    data={params.data}
                    onClick={openRemarksPopup}
                    buttontext="Add Remarks"
                />
            ),
        },
            { field: "orderId", headerName: "Order ID" },
            { field: "wayBill", headerName: "WayBill" },
            { field: "courier", headerName: "Courier" },
            { field: "customerName", headerName: "Customer Name" },
            { field: "mobile", headerName: "Mobile" },
            { field: "email", headerName: "Email" },
            { field: "pincode", headerName: "Pincode" },
            { field: "city" },
            { field: "totalAmount", headerName: "Total Amount" },
            { field: "paymentType", headerName: "Payment Type" },
            { field: "diseaseName", headerName: "Disease Name" },
            { field: "courierStatus", headerName: "Courier Status" },
        ]
    

    // All Grid Columns
    
    return (
       <>
    {message && <CommonMessage text={message} />}

    <h4 className="mb-3">
        {ndrStatus ? "Done NDR List" : "Pending NDR List"}
    </h4>

    <div className="row mb-3">
        <div className="col-md-3">
            <label className="form-label">NDR Status</label>
            <select
                className="form-select"
                value={ndrStatus ? "true" : "false"}
                onChange={(e) => {
                    setNdrStatus(e.target.value === "true");
                    setRefreshKey((prev) => prev + 1);
                }}
            >
                <option value="false">Pending</option>
                <option value="true">Done</option>
            </select>
        </div>
    </div>

    <CommonOrders
        key={refreshKey}
        statusId={8}
        ndrStatus={ndrStatus}
        columnDefs={columnDefs}
    />

         <Modal
                show={showModal}
                onHide={closeRemarksPopup}
                centered
            >
                <Modal.Header
    closeButton
    style={{ background: "#0d2b45", color: "#fff" }}
>
    <Modal.Title>
        Order ID : {selectedRow?.orderId}
    </Modal.Title>
</Modal.Header>

                <Modal.Body>
    {/* Response Remark */}
    <div className="mb-3">
        <label className="form-label">
            Response Remark <span className="text-danger">*</span>
        </label>

        <textarea
            rows={3}
            name="remarks"
            className={`form-control ${
                errors.remarks ? "is-invalid" : ""
            }`}
            value={formData.remarks}
            onChange={handleChange}
        />

        {errors.remarks && (
            <div className="invalid-feedback">
                {errors.remarks}
            </div>
        )}
    </div>

    {/* Response Status */}
    <div className="mb-3">
        <label className="form-label">
            Response Status <span className="text-danger">*</span>
        </label>

        <div className="form-check">
            <input
                className="form-check-input"
                type="radio"
                name="responseStatus"
                id="return"
                value="Return"
                checked={formData.responseStatus === "Return"}
                onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="return">
                Return
            </label>
        </div>

        <div className="form-check">
            <input
                className="form-check-input"
                type="radio"
                name="responseStatus"
                id="reattempt"
                value="Re Attempt"
                checked={formData.responseStatus === "Re Attempt"}
                onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="reattempt">
                Re Attempt
            </label>
        </div>

        {errors.responseStatus && (
            <div className="text-danger small">
                {errors.responseStatus}
            </div>
        )}
    </div>

    {/* Response Date */}
    <div className="mb-3">
        <label className="form-label">Response Date</label>

        <input
            type="date"
            name="responseDate"
            className={`form-control ${
                errors.responseDate ? "is-invalid" : ""
            }`}
            value={formData.responseDate}
            onChange={handleChange}
        />

        {errors.responseDate && (
            <div className="invalid-feedback">
                {errors.responseDate}
            </div>
        )}
    </div>
</Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={closeRemarksPopup}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="primary"
                        onClick={handleRemarksNDR}
                        disabled={remarksLoading}
                    >
                        {remarksLoading ? "Saving..." : "Save"}
                    </Button>
                </Modal.Footer>
            </Modal>
           
        </>
    );
}
export default PendingNDR;